import { useGetAssetsQuery } from 'app/generated/hygraph';
import HygraphService from 'app/services/HygraphService';

const { client } = HygraphService();

export default function useAssets() {
  return useGetAssetsQuery(client);
}
